module.exports = __webpack_public_path__ + "img/like-shapes.8e8ebcb0.svg";